<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
    style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='出科管理' label2="延期人员申请出科修改" url="/cycle/out/delayoutapplymanage"></PageHead>
      <div class="m-portlet__body">
        <el-form ref="form" :model="form" label-width="80px">
          <el-row style="font-size: 18px;line-height: 50px;">
            <el-col :span="24">
              学员信息
            </el-col>
          </el-row>
          <el-row style="line-height: 30px;font-size: 16px;">
            <el-col :span="8">
              <el-form-item label="姓名：" label-width="90px">
                {{StuName}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="轮转科室：" label-width="90px">
                {{CPSec}}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="轮转时间：" label-width="90px">
                {{CPDate}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="font-size: 18px;line-height: 50px;">
            <el-col :span="24">
              考核类型
            </el-col>
          </el-row>
          <!-- <el-row style="line-height: 30px;font-size: 16px;">
            <el-col :span="24">
              <el-form-item label="考核类型：" label-width="90px">
                <el-select v-model="form.examtype" filterable placeholder="请选择">
                  <el-option label="请选择" value=""></el-option>
                  <el-option label="正常出科" value="1"></el-option>
                  <el-option label="请假" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <div>
            <el-row style="font-size: 18px;line-height: 50px;">
              <el-col :span="24">
                设置考官
              </el-col>
            </el-row>
            <el-row style="line-height: 30px;font-size: 16px;">
              <el-col :span="8">
                <el-form-item label="考官1：" label-width="90px">
                  <el-select v-model="form.tec1" filterable placeholder="请选择">
                    <el-option label="请选择" value=""></el-option>
                    <el-option v-for="item in tecOptions" :key="item.TecID" :label="item.TrueName" :value="item.TecID">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="考官2：" label-width="90px">
                  <el-select v-model="form.tec2" filterable placeholder="请选择">
                    <el-option label="请选择" value=""></el-option>
                    <el-option v-for="item in tecOptions" :key="item.TecID" :label="item.TrueName" :value="item.TecID">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="考官3：" label-width="90px">
                  <el-select v-model="form.tec3" filterable placeholder="请选择">
                    <el-option label="请选择" value=""></el-option>
                    <el-option v-for="item in tecOptions" :key="item.TecID" :label="item.TrueName" :value="item.TecID">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="font-size: 18px;line-height: 50px;">
              <el-col :span="24">
                设置考核信息
              </el-col>
            </el-row>
            <el-row style="line-height: 30px;font-size: 16px;">
              <el-col :span="24">
                <el-form-item label="考核项目：" label-width="90px">
                  <el-select v-model="form.projectid" filterable placeholder="请选择">
                    <el-option label="请选择" value=""></el-option>
                    <el-option v-for="item in projectOptions" :key="item.DictItemID" :label="item.DictItemName"
                      :value="item.DictItemID">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="line-height: 30px;font-size: 16px;">
              <el-col :span="24">
                <el-form-item label="考核时间：" label-width="90px">
                  <div>
                    <el-radio-group v-model="form.outdate" @change="LoadExamTime">
                      <el-radio-button v-for="item in dateOptions" :key="item.value" :value="item.value"
                        :label="item.value">{{item.value}}<br><br>{{item.label}}</el-radio-button>
                    </el-radio-group>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="line-height: 30px;font-size: 16px;" v-if="outtimeOptions != null">
              <el-col :span="24">
                <el-form-item label="考核场次：" label-width="90px">
                  <div>
                    <div>
                      <el-radio-group v-model="form.outtime">
                        <div v-for="item in outtimeOptions" :key="item.id">
                          <el-radio :disabled="item.disabled" :label="item.id" border>{{item.name}}，已预约
                            {{item.number}} 人。
                          </el-radio>
                        </div>
                      </el-radio-group>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
            <el-button type="success" icon="el-icon-s-order" @click="Save()"
              v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'OutEdit',
    data() {
      return {
        form: {
          token: '',
          username: '',
          rolelevel: '',
          cpid: '',
          tec1: '',
          tec2: '',
          tec3: '',
          projectid: '',
          outdate: '',
          outweek: '',
          outtime: '',
          examtype: '1',
          oaid: ''
        },
        managesec: '',
        StuName: '',
        CPSec: '',
        CPDate: '',
        tecOptions: [],
        dateOptions: [],
        projectOptions: [],
        fullscreenLoading: false,
        weeks: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
        outtimeOptions: null
      }
    },
    methods: {
      Save: function() {
        if (this.form.examtype == '') {
          this.$message({
            message: '请选择考核类型',
            type: 'warning'
          })
          return
        }

        if (this.form.examtype == 1) {
          if (this.form.tec1 == '') {
            this.$message({
              message: '考官1 没有设置',
              type: 'warning'
            })
            return
          }

          if (this.form.tec2 == '') {
            this.$message({
              message: '考官2 没有设置',
              type: 'warning'
            })
            return
          }

          if (this.form.tec3 == '') {
            this.$message({
              message: '考官3 没有设置',
              type: 'warning'
            })
            return
          }

          if (this.form.tec1 == this.form.tec2) {
            this.$message({
              message: '考官1 与 考官2 不能设置相同带教老师',
              type: 'warning'
            })
            return
          }

          if (this.form.tec1 == this.form.tec3) {
            this.$message({
              message: '考官1 与 考官3 不能设置相同带教老师',
              type: 'warning'
            })
            return
          }

          if (this.form.tec2 == this.form.tec3) {
            this.$message({
              message: '考官2 与 考官3 不能设置相同带教老师',
              type: 'warning'
            })
            return
          }

          if (this.form.projectid == '') {
            this.$message({
              message: '考核项目 没有设置',
              type: 'warning'
            })
            return
          }

          if (this.form.outdate == '') {
            this.$message({
              message: '考核时间 没有设置',
              type: 'warning'
            })
            return
          }

          if (this.form.outtime == '') {
            this.$message({
              message: '考核场次 没有设置',
              type: 'warning'
            })
            return
          }
        }

        this.fullscreenLoading = true
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/EditOutApply', this.form)
          .then(res => {
            if (res.data.Code === 0) {
              that.$message({
                message: '保存成功',
                type: 'success'
              })
              console.log('保存成功')
              that.$router.push('/main/cycle/out/delayoutapplymanage')
            } else {
              that.$message({
                message: res.data.Msg + '，' + res.data.Data,
                type: 'error'
              })
            }
            that.fullscreenLoading = false
          })
          .catch(err => {
            console.log(err)
            that.$message({
              message: '保存失败',
              type: 'error'
            })
            that.fullscreenLoading = false
          })
      },
      LoadTec: function() {
        var that = this
        var args = {
          token: this.form.token,
          username: this.form.username,
          rolelevel: this.form.rolelevel,
          pageSize: 9999,
          currentPage: 1
        }
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APITeacher/List', args, function(data) {
          var tecdata = data.Data
          tecdata.forEach(function(item) {
            var arg = {
              TecID: item.TecID,
              TrueName: item.TrueName + '(' + item.CardNo + ')'
            }
            that.tecOptions.push(arg)
          })
          that.LoadProject()
        }, null, null, null)
      },
      LoadProject: function() {
        var that = this
        var args = {
          token: this.form.token,
          dictid: this.$utils.DictEnum.project,
          managesec: this.managesec
        }
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/DictList', args, function(data) {
          that.projectOptions = data.Data
          that.LoadCPInfo()
        }, null, null, null)
      },
      LoadCPInfo: function() {
        var that = this
        var args = {
          token: this.form.token,
          id: this.form.cpid,

        }
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/ViewInfo', args, function(data) {
          var info = data.Data
          console.log(info)
          that.StuName = info.CPStuName
          that.CPSec = info.SecName

          var date = new Date(info.CPBeginDate)
          var y = date.getFullYear()
          var m = date.getMonth() + 1
          var d = date.getDate()
          var begindate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d)

          date = new Date(info.CPEndDate)
          y = date.getFullYear()
          m = date.getMonth() + 1
          d = date.getDate()
          var enddate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d)

          that.CPDate = begindate + ' - ' + enddate

          that.LoadOutDate()
        }, null, null, null)
      },
      LoadOutDate: function() {
        var now = new Date()
        var year = now.getFullYear()
        var month = now.getMonth() + 1
        var nowdate = new Date(year, month, 0)
        var enddate = year + '-' + month + '-' + nowdate.getDate()
        var index = 0
        var i = 0
        while (index < 7) {
          var date = new Date(enddate)
          date = date.setDate(date.getDate() - i)
          date = new Date(date)
          var weekindex = date.getDay()
          var week = this.weeks[weekindex]
          if (week == '星期日' || week == '星期六') {
            i++
          } else {
            var y = date.getFullYear()
            var m = date.getMonth() + 1
            var d = date.getDate()
            var outdate = y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)

            var arg = {
              value: outdate,
              label: week
            }
            this.dateOptions.push(arg)
            i++
            index++
          }
        }
        this.LoadOutApplyInfo()
      },
      LoadExamTime: function(obj) {
        this.form.outtime = ''
        var date = obj
        date = new Date(date)
        var weekindex = date.getDay()
        this.form.outweek = this.weeks[weekindex]
        var that = this
        var args = {
          token: this.form.token,
          date: obj,
          cpid: this.form.cpid
        }
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/LoadOutNumberForEdit', args, function(data) {
          that.outtimeOptions = []
          var list = data.Data
          list.forEach(function(item) {
            var id = item.DictItemID
            var name = item.DictItemName
            var value = item.DictItemValue
            var number = item.Number
            var disabled = true

            if (number * 1 >= 10) {
              disabled = true
            } else {
              disabled = false
            }

            if (value == 1) {
              disabled = true
            }

            var arg = {
              id: id,
              name: name,
              number: number,
              disabled: disabled,
            }
            that.outtimeOptions.push(arg)
          })
        }, null, null, null)
      },
      LoadOutApplyInfo: function() {
        var that = this
        var args = {
          token: this.form.token,
          cpid: this.form.cpid,
          oaid: this.form.oaid
        }
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/OutApplyInfo', args, function(data) {
          var info = data.Data
          that.form.examtype = info.ExamType.toString()
          that.form.projectid = info.ProjectID
          var date = new Date(info.ExamDate)
          var y = date.getFullYear()
          var m = date.getMonth() + 1
          var d = date.getDate()
          that.form.outdate = y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
          that.LoadExamTime(that.form.outdate)
          that.form.outweek = info.ExamWeek
          that.form.outtime = info.ExamTime
          that.LoadOutApplyTec()
        }, null, null, null)
      },
      LoadOutApplyTec: function() {
        var that = this
        var args = {
          token: this.form.token,
          cpid: this.form.cpid,
          oaid:this.form.oaid
        }
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/OutApplyTecInfo', args, function(data) {
          var list = data.Data
          for (var i = 0; i < list.length; i++) {
            if (i == 0) {
              that.form.tec1 = list[i].TecID
            } else if (i == 1) {
              that.form.tec2 = list[i].TecID
            } else if (i == 2) {
              that.form.tec3 = list[i].TecID
            }
          }
        }, null, null, null)
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.username = sessionStorage.getItem('username')
      this.form.rolelevel = sessionStorage.getItem('rolelevel')
      this.form.cpid = this.$route.params.id
      this.managesec = this.$route.params.managesec
      this.form.oaid = this.$route.params.oaid
      this.LoadTec()
    }
  }
</script>

<style>
</style>
